import { request } from "./api-client";
import type { AIProvider } from "./types";

export type { AIProvider };

export async function getProviders(): Promise<{ data: AIProvider[] }> {
  return request("/ai/providers");
}

export async function createProvider(data: {
  id: string;
  name: string;
  adapterType: string;
  apiKey: string;
  baseUrl: string;
  rpmLimit?: number;
  rpsLimit?: number;
}): Promise<{ data: { id: string } }> {
  return request("/ai/providers", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateProvider(
  id: string,
  data: { name: string; baseUrl: string },
): Promise<{ data: { id: string; updatedAt: string } }> {
  return request(`/ai/providers/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function updateProviderKey(
  id: string,
  apiKey: string,
): Promise<{ data: { id: string; updatedAt: string } }> {
  return request(`/ai/providers/${id}/key`, {
    method: "PUT",
    body: JSON.stringify({ apiKey }),
  });
}

export async function revealProviderKey(
  id: string,
): Promise<{ data: { id: string; apiKey: string } }> {
  return request(`/ai/providers/${id}/key`);
}

export async function activateProvider(
  id: string,
): Promise<{ data: { id: string; isActive: boolean } }> {
  return request(`/ai/providers/${id}/activate`, {
    method: "PUT",
  });
}

export async function deactivateProvider(
  id: string,
): Promise<{ data: { id: string; isActive: boolean } }> {
  return request(`/ai/providers/${id}/deactivate`, {
    method: "PUT",
  });
}

export async function updateRateLimits(
  id: string,
  data: { rpmLimit?: number; rpsLimit?: number },
): Promise<{ data: { id: string; rpmLimit: number | null; rpsLimit: number | null } }> {
  return request(`/ai/providers/${id}/rate-limits`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteProvider(id: string): Promise<void> {
  return request(`/ai/providers/${id}`, {
    method: "DELETE",
  });
}
